<template>
  <div class="login-page">
      <div class="login-title">四川省知识产权发展研究中心专利价值评估系统</div>
      <div class="login-title-en">Sichuan Intellectual Property Development Research Center Patent Value Evaluation System</div>
      <div class="login-content">
        <!-- <div class="content-item">
          <div class="content-person" @click="jumpUserLogin()">
              <img src="../assets/img/person-icon.png">
              <span style="padding-left: 40px;">个人用户</span>
          </div>
          <div class="content-team" @click="jumpUserLogin()">
            <img src="../assets/img/team-icon.png">
            <span style="padding-left: 40px;">集团用户</span>
          </div>
        </div> -->
        <div class="content-item" style="margin-left: 200px;">
          <div class="content-agent" @click="jumpUserLogin()">
            <div style="padding-top: 95px;">
              <img src="../assets/img/agent-icon.png">
            </div>
            <div>
              <span>用户登录</span>
            </div>
          </div>
        </div>
        <div class="content-item" style="margin-left: 30px;">
          <div class="content-admin" @click="jumpAdminLogin()">
            <div style="padding-top: 95px;">
              <img src="../assets/img/admin-icon.png">
            </div>
            <div>
              <span>管理登录</span>
            </div>
          </div>
        </div>
      </div>
      <bottomNav></bottomNav>
  </div>
</template>
<script type="text/ecmascript-6">
import bottomNav from '../components/bottomNav'
export default {
  name: 'login',
  data() {
    return {
      record_company: '',
      record_icp: ''
    }
  },
  // 注册组件
  components: {
    bottomNav
  },
  // 创建完毕状态(里面是操作)
  created() {
    
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 跳转用户登陆
    jumpUserLogin(){
      this.$router.push({ name: 'userLogin'});
    },
    // 跳转专家登陆
    jumpAgentLogin(){
      this.$router.push({ name: 'agentLogin'});
    },
    // 跳转管理登陆
    jumpAdminLogin(){
      this.$router.push({ name: 'adminLogin'});
    },
  }
}
</script>

<style scoped>
  .login-page {
    text-align: center;
    height: 100%;
  }
  .login-title {
    font-size: 36px;
    font-weight: 700;
    padding-top: 120px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .login-content {
    display: flex;
    width: 1200px;
    margin: 80px auto;
  }
  .content-item {
    width: 380px;
    height: 300px;
    text-shadow: 0px 2px 4px #333;
  }
  .content-item img {
    filter: drop-shadow(0 4px 2px rgba(0,0,0,0.25));
  }
  .content-person {
    position: relative;
    height: 135px;
    line-height: 135px;
    font-size: 24px;
    color: #ffffff;
    border-radius: 20px;
    cursor: pointer;
    background-image: url('./../assets/img/bg-person.png');
    background-size: cover;
  }
  .content-person img {
    width: 25px;
    height: 30px;
    position: absolute;
    top: 50%;
    left: 35%;
    transform: translate(-50%, -50%);
  }
  .content-team {
    position: relative;
    height: 135px;
    line-height: 135px;
    font-size: 24px;
    color: #ffffff;
    margin-top: 30px;
    border-radius: 20px;
    cursor: pointer;
    background-image: url('./../assets/img/bg-team.png');
    background-size: cover;
  }
  .content-team img {
    width: 43px;
    height: 30px;
    position: absolute;
    top: 50%;
    left: 33%;
    transform: translate(-50%, -50%);
  }
  .content-agent {
    height: 300px;
    font-size: 24px;
    color: #ffffff;
    border-radius: 20px;
    cursor: pointer;
    background-image: url('./../assets/img/bg-agent.png');
    background-size: cover;
  }
  .content-admin {
    height: 300px;
    font-size: 24px;
    color: #ffffff;
    border-radius: 20px;
    cursor: pointer;
    background-image: url('./../assets/img/bg-admin.png');
    background-size: cover;
  }
</style>


// WEBPACK FOOTER //
// src/views/login.vue